export default "__VITE_ASSET__1702ef53__"